import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navigation from '../Components/Navigation';
import debounce from 'lodash.debounce';

class NavigationContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuLinks: [],
        };
        this.setMenu = this.setMenu.bind(this);
        this.debouncedQuery = this.debouncedQuery.bind(this);
    }

    componentDidMount() {
        this.setMenu();
        window.addEventListener("resize", this.debouncedQuery);
    }
    
    componentWillUnmount() {
        window.removeEventListener("resize", this.debouncedQuery);
    }

    debouncedQuery = debounce(() => this.setMenu(), 500);

    setMenu() {
        if (window.innerWidth < 640) {
            this.setState(() => ({
                menuLinks: this.props.linksMobile
            }));
        } else {
            this.setState(() => ({
                menuLinks: this.props.links
            }));
        }
    }

    render() {
        return (
            <Navigation links={this.state.menuLinks} />
        );
    }
}

const mapStateToProps = state => {
    return {
        links: state.navigation.contentLinks,
        linksMobile: state.navigationMobile.contentLinks,
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationContainer);